import React, { useContext, useEffect, useState } from 'react'
import { Button, Form, Icon, Modal } from 'semantic-ui-react'
import { useDispatch, useSelector } from 'react-redux'
import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { history } from '../../redux/store'

import {
  GetUserTemplates,
  AssignTemplateToDevice,
} from '../../services/configuration-template'
import StatusDialog from '../status-dialog'
import { RefreshCustomerDeviceList } from '../../redux/actions/devices'
import IntelMsg from '../ItelMsg'
import { DeviceViewContext } from '../device/device-info-view/deviceView'

export default function ConfigurationModal() {
  const [templatesList, setTemplateList] = useState([])
  const { register, errors, handleSubmit, clearErrors } = useForm()
  const [showDialog, setShowDialog] = useState(false)
  const [disableSubmit] = useState(false)
  const [statusDialogContent, setStatusDialogContent] = useState('')
  const { email, productName } = useSelector((store) => ({
    email: store.auth.userEmail,
    productName: store.product.productName,
  }))
  const { openTemplateDialog, setOpenTemplateDialog, deviceData } =
    useContext(DeviceViewContext)

  const { t } = useTranslation()
  const dispatch = useDispatch()

  async function onSubmit(data) {
    clearErrors()
    AssignTemplateToDevice(
      email,
      productName,
      deviceData,
      data.templateName,
    ).then((response) => {
      setOpenTemplateDialog(false)
      dispatch(RefreshCustomerDeviceList(true))
      if (!response.success) {
        setStatusDialogContent(response.msg)
        setShowDialog(true)
      }
    })
  }

  useEffect(
    () =>
      GetUserTemplates(email, productName).then((list) => {
        setTemplateList(list)
      }),
    [],
  )

  return (
    <>
      <Modal
        onClose={() => setOpenTemplateDialog(false)}
        onOpen={() => setOpenTemplateDialog(true)}
        open={openTemplateDialog}
        size="tiny"
        style={{ position: 'relative', height: 'auto' }}
      >
        <Modal.Header style={{ background: '#1678c2', color: 'white' }}>
          <IntelMsg id="selectConfigurationTemplate" />
        </Modal.Header>
        <Modal.Content scrolling>
          <Form
            id="assignTemplate"
            onSubmit={handleSubmit(onSubmit)}
            widths="equal"
          >
            <Form.Group>
              <Form.Field>
                <label htmlFor="templateName">
                  <IntelMsg id="chooseYourTemplate" />
                </label>
                <select
                  ref={register({
                    validate: { isValidSelect: (value) => value !== '-1' },
                  })}
                  name="templateName"
                >
                  <option value={-1}>{t('selectTemplate')}</option>
                  {templatesList
                    ? templatesList.map((item) => (
                        <option
                          value={item['template name']}
                          key={item['template name']}
                        >
                          {item['template name']}
                        </option>
                      ))
                    : null}
                </select>
                <small style={{ color: 'red' }}>
                  {errors.templateName &&
                  errors.templateName.type === 'isValidSelect'
                    ? 'Required'
                    : '**'}
                </small>
              </Form.Field>
            </Form.Group>
          </Form>
          <Button
            content="Create new template"
            labelPosition="right"
            icon="add"
            style={{ background: '#303D54' }}
            onClick={() => {
              setOpenTemplateDialog(false)

              history.push({
                pathname: '/template',
                search: `?deviceID=${deviceData.id}&deviceName=${deviceData.name}`,
              })
            }}
            positive
          />
        </Modal.Content>
        <Modal.Actions>
          <Button
            type="submit"
            form="assignTemplate"
            color="blue"
            disabled={disableSubmit}
          >
            <IntelMsg id="submit" />
          </Button>
        </Modal.Actions>
      </Modal>
      <StatusDialog
        showDialog={showDialog}
        setShowDialog={setShowDialog}
        dialogHeader="Device Configuration Issue"
        dialogContent={
          <>
            <Icon name="exclamation triangle" size="huge" color="red" />
            <p style={{ fontSize: 'x-large' }}>{statusDialogContent}</p>
          </>
        }
      />
    </>
  )
}
